export default __webpack_public_path__ + "static/media/buttermilks-crop.af48cfc8.jpg";